<template>
	<transition name="fade">
		<div class="vdialog" :class="{'vdialog-info':type==='info'}" v-if="show">
			<div v-if="isConfimBox" class="vdialog-body">
        <div class="vdialog-title">
          {{title}}
        </div>
        <div class="vdialog-content">
          {{content}}
        </div>
        <div class="vdialog-btn-group" >
          <button @click="cancel" v-if="type==='confim'">取消</button>
          <button @click="success">确定</button>
        </div>
			</div>
      <div v-if="isInputBox" class="vdialog-input-body">
        <input value="" v-model="inputs" class="code" type="text" :placeholder="placeHolder">
        <div :class ="{'button-action--disabled':noInputs}" @click="success" class="button-action">{{actionName}}</div>
        <img @click="cancel"  :src="require('@/assets/icon/close-float.png')" class="close"/>
      </div>
			<div v-if="isInfoBox" class="vdialog-info-body">
				<div class="content">
					<h2>{{title}}</h2>
					<ul class="vdialog-info-list">
						<li v-if="isArr(content)" :key="index" v-for="(info,index) in content">
							<span>{{index+1}}.</span>
							<p >
							{{info}}
						</p>
						</li>
					</ul>
				</div>
				 <img @click="cancel"  :src="require('@/assets/icon/close-float.png')" class="close"/>
			</div>
			<div v-if="isAlipay" class="vdialog-alipay" @click="cancel">
				<img :src="require('@/assets/icon/m.png')" alt="">
				<div class="text">
					<p>支付宝无法在微信中使用</p>
					<p>请使用浏览器打开</p>
				</div>
			</div>
		</div>
	</transition>
</template>
<script>
export default {
  name: "vdialog",
  data() {
    return {
      // 目前可以使用的type有：
      //
      // input ：显示一个文本输入框，在promise的resolve中返回输入内容。reject捕获用户手动关闭对话框。
      // input参数：placeHolder -> 输入框占位符。actionName：下方确认按钮的名字。
      //
      // confim：显示一个选择框。resolve捕获用户确认，reject捕获用户取消。
      // alert：显示一个提示框。
      // 提示框和选择框框的参数：title：提示框标题；content：提示框正文。
      type: "",
      show: false,
      title: "提示",
      content: "你确定吗？",
      inputs: "",
      placeHolder: "请在这里输入内容",
      actionName: "确定"
    };
  },
  methods: {
    success() {
      this.show = false;
    },
    cancel() {
      this.show = false;
    },
    isArr() {
      return this.content instanceof Array;
    }
  },

  computed: {
    isConfimBox() {
      return this.type === "confim" || this.type === "alert";
    },
    isInputBox() {
      return this.type === "input";
    },
    isInfoBox() {
      return this.type === "info";
    },
    noInputs() {
      return this.inputs === "";
    },
    isAlipay() {
      return this.type === "alipay";
    }
  }
};
</script>
<style lang="scss" scoped>
@import "./style.scss";
</style>


